<template>
  <SectionTemplate
    title="无需拍摄剪辑，AI一键生成专业级视频"
    subTitle="3D AI 视频生成"
    theme="dark"
  >
    <div class="card-list">
      <FeatureCard
        v-for="(feature, index) in featureList"
        :key="index"
        v-bind="feature"
        btnText="免费试用"
        :action="handleTrail"
      />
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import FeatureCard from '@/design/components/feature-card/index.vue';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';

const handleTrail = () => {
  emit('trial');
};

const emit = defineEmits<{
  (e: 'trial'): void;
}>();

const featureList = [
  {
    title: `人人都能轻松获得
专业级视频效果`,
    description:
      '无需拍摄、剪辑或制作经验，普通人也能轻松创作出媲美专业制作的视频。从灯光到运镜，每一帧画面都精准还原制作团队的专业水准。',
    video: getFeUrl('/youyan-platform/main/video-feature/1.webm'),
    image: getFeUrl('/youyan-platform/main/video-feature/1.png?x-oss-process=image/format,webp'),
    theme: 'dark' as const,
    videoDesc: '用有言AI可以轻松生成专业级数字人视频',
  },
  {
    title: `短视频、长演讲
任意时长、秒级生成`,
    description:
      '无论是30秒的短视频，还是60分钟的专业讲座，有言都能快速生成。3D数字人表达自然生动，配合专业镜头调度，即使视频再长，也能清晰传递信息，持续吸引观众。',
    video: getFeUrl('/youyan-platform/main/video-feature/2.webm'),
    image: getFeUrl('/youyan-platform/main/video-feature/2.png?x-oss-process=image/format,webp'),
    reverse: true,
    theme: 'dark' as const,
    videoDesc: '有言可以生成任意时长的AI数字人视频',
  },
  {
    title: `海量角色、场景、镜头自由搭配
轻松搞定各类视频需求`,
    description:
      '3000+可编辑、超写实3D数字人形象、近千款高质量3D场景，还有不同音色、动作风格和镜头组合任你搭配。无论是企业培训、社媒运营还是活动主持视频，有言轻松适配，一站式满足多场景视频需求。',
    video: getFeUrl('/youyan-platform/main/video-feature/3.webm'),
    image: getFeUrl('/youyan-platform/main/video-feature/3.png?x-oss-process=image/format,webp'),
    theme: 'dark' as const,
    videoDesc: '有言提供海量AI数字人角色、场景以及镜头可以自由搭配',
  },
];
</script>

<style lang="scss" scoped src="./pc.scss" />
<style lang="scss" scoped src="./mobile.scss" />
